import { defineStore } from 'pinia';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlertStore } from '@/rennovation/planning-view/store/useAlertStore';

interface DeleteAbsencePayload {
	id: string;
	changeComment: string | null;
}

export const usePlanningBridgeStore = defineStore('planningBridge', () => {
	const { t } = useI18n();

	const vuex = useStore();
	const alertStore = useAlertStore();

	// const initLoading = computed(() => vuex.state.planning.initLoading);
	// const loading = computed(() => vuex.state.planning.loading);

	const drivers = computed(() => vuex.state.planning.drivers);
	const driversRef = computed(() => vuex.state.planning.driversRef);
	const daysData = computed(() => vuex.state.planning.days);
	const daysRef = computed(() => vuex.state.planning.daysRef);
	const recentDuties = computed(() => vuex.state.planning.recentDuties);
	const setup = computed(() => vuex.state.setup.setup);
	const token = computed(() => vuex.state.auth.token);
	const editor = computed(() => vuex.state.auth.user);
	const hasPermission = computed(() => vuex.state.auth.user.permissions['days.edit']);
	const extraPayAccounts = computed(() => vuex.state.setup.setup.extraPay_accounts);
	const rotationPlans = computed(() => vuex.state.Rotation.plans);

	const user = computed(() => vuex.state.auth.user);
	const singleStatistics = computed(() => vuex.state.planning.singleStatistics);
	const extraPayCurrency = computed(() => vuex.state.planning.extraPayCurrency);

	const isBeforeFirstPastDay = computed(() => vuex.getters['days/isBeforeFirstPastDay']);

	const fetchRecentDuties = async (): Promise<void> => {
		try {
			await vuex.dispatch('planning/loadRecentDuties');
		} catch (error) {
			const errorMessage = error?.response?.data?.message || t('data_load_failed');
			alertStore.showAlert(errorMessage, 'error');
			throw error;
		}
	};

	const loadSingleStatistics = (payload: { date: string; user: any }) => {
		try {
			return vuex.dispatch('planning/loadSingleStatistics', payload);
		} catch (error) {
			const errorMessage = error?.response?.data?.message || t('data_load_failed');
			alertStore.showAlert(errorMessage, 'error');
			throw error;
		}
	};

	const loadSetup = () => {
		try {
			return vuex.dispatch('setup/load');
		} catch (error) {
			const errorMessage = error?.response?.data?.message || t('data_load_failed');
			alertStore.showAlert(errorMessage, 'error');
			throw error;
		}
	};
	const loadRotation = () => {
		try {
			return vuex.dispatch('Rotation/load');
		} catch (err) {}
	};

	const createAbsence = async (payload: unknown): Promise<void> => {
		try {
			await vuex.dispatch('userActions/createAbsence', payload);
		} catch (error) {
			console.error('Failed to create absence via bridge store:', error);
			throw error;
		}
	};

	const updateAbsence = async (payload: unknown): Promise<void> => {
		try {
			await vuex.dispatch('userActions/updateAbsence', payload);
		} catch (error) {
			console.error('Failed to update absence via bridge store:', error);
			throw error;
		}
	};

	const deleteAbsence = async (payload: DeleteAbsencePayload): Promise<void> => {
		try {
			await vuex.dispatch('userActions/deleteAbsence', payload);
		} catch (error) {
			console.error('Failed to delete absence via bridge store:', error);
			throw error;
		}
	};

	return {
		editor,
		singleStatistics,
		extraPayCurrency,
		drivers,
		driversRef,
		daysRef,
		recentDuties,
		daysData,
		setup,
		user,
		token,
		extraPayAccounts,
		rotationPlans,
		isBeforeFirstPastDay,
		hasPermission,
		loadSetup,
		createAbsence,
		updateAbsence,
		deleteAbsence,
		fetchRecentDuties,
		loadSingleStatistics,
		loadRotation,
	};
});
